/**
 * Customer route view.
 *
 * Explains routing behavior, guards, and response semantics.
 */
import { useCustomerRouteViewModel } from './hooks'
import type { CustomerRouteMode } from './routes'
import {
  renderCustomerAuthRoute,
  renderCustomerProtectedRoute,
} from './customerRouteView.renderers'

type Props = {
  mode: CustomerRouteMode
  currentSlug: string
  onNavigate: (targetPath: string) => void
}

/**
 * Customer route view.
 *
 * Explains routing behavior, guards, and response semantics.
 */
export const CustomerRouteView = ({ mode, currentSlug, onNavigate }: Props) => {
  const viewModel = useCustomerRouteViewModel({
    mode,
    currentSlug,
    onNavigate,
  })

  const authRoute = renderCustomerAuthRoute({ mode, onNavigate, viewModel })
  if (authRoute) return authRoute
  return renderCustomerProtectedRoute({ onNavigate, viewModel })
}
